import { ActionType, } from 'typesafe-actions';

import * as actions from './actions';

export const FETCH_EXAMPLES_REQUEST = 'FETCH_EXAMPLES_REQUEST';
export const FETCH_EXAMPLES_SUCCEEDED = 'FETCH_EXAMPLES_SUCCEEDED';
export const FETCH_EXAMPLES_FAILED = 'FETCH_EXAMPLES_FAILED';
export type ExamplesAction = ActionType<typeof actions>;
